import React from 'react';
export function EditIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.912 4.527L19.5 3.111a2.978 2.978 0 00-2.12-.88 2.98 2.98 0 00-2.118.873L3.927 14.4a1 1 0 00-.227.375c-.01.03-.026.056-.034.085L2.24 20.52a1 1 0 001.211 1.215L9.11 20.33c.033-.008.062-.026.094-.037a1 1 0 00.367-.223l11.331-11.3a3 3 0 00.01-4.243zM5.171 17.067l1.662 1.666.081.08-2.328.579.585-2.325zm3.7.878l-1.412-1.416-1.412-1.418 8.5-8.472 1.412 1.416 1.412 1.416-8.5 8.474zM19.494 7.353l-.709.706-1.412-1.416-1.412-1.417.708-.706a1 1 0 011.412.003L19.5 5.94a1 1 0 01-.006 1.414z"
  }));
}